export function reorderRouteMember(
  memberIds: readonly string[],
  draggedId: string,
  targetId: string,
): string[] {
  const sourceIndex = memberIds.indexOf(draggedId);
  const targetIndex = memberIds.indexOf(targetId);
  if (sourceIndex < 0 || targetIndex < 0 || sourceIndex === targetIndex) return [...memberIds];

  const next = [...memberIds];
  const [dragged] = next.splice(sourceIndex, 1);
  next.splice(targetIndex, 0, dragged);
  return next;
}

export function moveRouteMember(
  memberIds: readonly string[],
  index: number,
  delta: -1 | 1,
): string[] {
  const nextIndex = index + delta;
  if (index < 0 || index >= memberIds.length || nextIndex < 0 || nextIndex >= memberIds.length) {
    return [...memberIds];
  }

  const next = [...memberIds];
  [next[index], next[nextIndex]] = [next[nextIndex], next[index]];
  return next;
}
